module.exports = __webpack_public_path__ + "static/img/9.e0cdc875.png";